import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'globalSearchFilter'
})
export class GlobalSearchFilter implements PipeTransform {
    datePipe = new DatePipe('en-US');

    transform(items: any[], searchValue: string ): any {
        if (!items) {
          return [];
        }

        if (!searchValue) {
           return items ? items : [];
        } else {
            return items.filter((item) => {
                const keys: any = Object.keys(item);
                let matched = false;
                keys.forEach((key) => {
                    if (!(isNaN(item[key]) && !isNaN(Date.parse(item[key])))) {
                        matched = String(item[key]).toLowerCase().includes(searchValue.toLowerCase()) ? true : matched;
                    } else {
                        matched = this.datePipe.transform(item[key], 'shortDate').includes(searchValue) ? true : matched;
                    }
                });
                return matched;
            });
        }
    }

}
